import { Card, CardContent, Hidden } from "@mui/material";
import { Outlet } from "react-router-dom";

export default function Auth() {
    return (
        <div className="h-full bg-background-default">
            <Hidden smDown>
                <Card className="center px-8 py-14 max-w-lg w-full">
                    <CardContent >
                        <Outlet />
                    </CardContent>
                </Card>
            </Hidden>
            <Hidden smUp>
                <div className="center w-full px-4 py-10">
                    <Outlet />

                </div>
            </Hidden>
        </div>
    )
}
